<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="akskList"
      style="width: 100.1%;"
    ></Table>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";

var tableAkskResourceVue = {};
export default {
  name: "TableAkskResource",
  data() {
    return {
      companyId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: "账户名称",
          key: "accountName"
        },
        {
          title: "账户Id",
          key: "accountIdString"
        },
        {
          title: "用户名",
          key: "userName"
        },
        {
          title: "AKSK",
          key: "accessKeyId"
        },
        {
          title: "创建时间",
          key: "createDate"
        },
        {
          title: "最后使用时间",
          key: "lastUsedDate"
        },
        {
          title: "状态",
          key: "status"
        }
      ],
      akskList: []
    };
  },
  beforeCreate: function() {
    tableAkskResourceVue = this;
  },
  created() {
    eventBus.$on("companyId", function(companyId) {
      tableAkskResourceVue.companyId = companyId;
    });
    eventBus.$on("iamUserName", function(iamUserName) {
      tableAkskResourceVue.iamUserName = iamUserName;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableAkskResourceVue.getDate();
    },
    // 显示数据
    getDate: function() {
      tableAkskResourceVue.$api.resourceManagement
        .pagingQueryAwsIamAKSK({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableAkskResourceVue.companyId,
          iamUserName: tableAkskResourceVue.iamUserName
        })
        .then(res => {
          this.akskList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAkskResourceVue.getDate();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAkskResourceVue.getDate();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/aksk/TableAkskResource.vue